import { computed, observable } from 'mobx';

import { query, serviceQueries } from '@estee/elc-service-bus';

import { Config } from '~domain/entities/Config';
import { IAppConfigWithRequestedBUIDKeys } from '~domain/entities/IConfig';

interface IConfigRepository {
    entity: Config;
}
export class ConfigRepository {
    @observable private _config: Config;

    constructor(opts: IConfigRepository) {
        this._config = opts.entity;
    }

    public fetchConfigs = async (configs: IAppConfigWithRequestedBUIDKeys) => {
        const buidConfig = await query(serviceQueries.GET_CONFIG, configs.requestedBuidConfigs);

        this._config.updateConfig({
            appConfig: configs.appConfig,
            buidConfig
        });
    };

    @computed
    public get config(): Config {
        return this._config;
    }
}
